import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Sprint Brief",
    desc: "We pin down the real problem, success metrics and what 'done' looks like.",
    color: "#FFD800",
  },
  {
    n: "02",
    title: "Design + Build",
    desc: "Daily Loom updates, async-friendly. You see progress every morning.",
    color: "#00E5FF",
  },
  {
    n: "03",
    title: "Ship + Iterate",
    desc: "We launch, instrument, and tune. Two weeks of post-launch polish included.",
    color: "#FF0055",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 px-4 sm:px-6"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-7">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#4A4A4A]">
              [03] — How we work
            </span>
            <h2 className="mt-3 font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter">
              Three steps. <br />
              <span className="text-stroke">No surprises.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 font-body text-[#4A4A4A]">
            Fixed scope. Fixed timeline. Fixed price. The only thing that varies is
            how hard we high-five at launch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`process-step-${i}`}
              className="relative brut-border brut-shadow bg-white p-7 brut-lift"
            >
              <div
                className="absolute -top-5 -left-5 w-16 h-16 brut-border flex items-center justify-center font-display font-black text-2xl"
                style={{ background: s.color }}
              >
                {s.n}
              </div>
              <h3 className="mt-6 font-display font-black uppercase text-2xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-[#4A4A4A] font-body">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
